import React, { useContext } from 'react';
import { UserContext } from './UserContext';
import { Link } from 'react-router-dom';

export default function UserWidget() {

    const [user] = useContext(UserContext);

    return (
        <Link style={{textDecoration: 'none'}} to="/signin">
            <div className="userWidget">
                <p className="userWidget__item">Settings |</p>
                {user && <p>| {user.displayName}</p>}
                {!user && <p className="userWidget__item">| Sign In</p>}
            </div>
        </Link>
    )
}